import { CaseModel, StateTransitionData, StateTypes } from "@ortho-next/nextray-core";
import { Context } from "./Context";
import { Actions, State, WorkflowRunning } from "./State";

/**
 * State indicating that the application is loading and restoring data. At the end it will the state loaded.
 */
export class Loading extends State {
  public stateDescription = {
    isWorkflowRunning: WorkflowRunning.none,
    isPointsPositioningRunning: false
  };

  constructor(context: Context) {
    super(context, {} as CaseModel, StateTypes.loading);
  }

  public initState(): void {
    // empty
  }

  protected handleChangeStateEvent<K extends keyof Actions>(event: K, args: Actions[K]): StateTransitionData {
    switch (event) {
      case "setInitialState":
        this.dispatchToMain(event, args)
        const state = (args as unknown as CaseModel).model?.state; // TODO check
        if (state) {
          const contextState = JSON.parse(state);

          switch (contextState.type) {
            case StateTypes.RPM:
              return { type: StateTypes.RPM, data: { caseModel: args, restore: contextState } };
          }

          console.error("Error. Cannot restore state.");
        }

        return { type: StateTypes.RPM, data: { caseModel: args } };
    }

    return super.handleNotChangeStateEvent(event, args);
  }

}
